/**
 * @generated SignedSource<<c08dda191021eec2bb16f2bb2f43b2cb>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { Fragment, ReaderFragment } from 'relay-runtime';
type TeamChooser_pipeline$fragmentType = any;
type TeamRow_organization$fragmentType = any;
type TeamRow_teamPipeline$fragmentType = any;
import type { FragmentType } from "relay-runtime";
declare export opaque type Page_pipeline$fragmentType: FragmentType;
export type Page_pipeline$data = {|
  +name: string,
  +organization: {|
    +id: string,
    +$fragmentSpreads: TeamRow_organization$fragmentType,
  |},
  +teams: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +$fragmentSpreads: TeamRow_teamPipeline$fragmentType,
      |},
    |}>,
  |},
  +$fragmentSpreads: TeamChooser_pipeline$fragmentType,
  +$fragmentType: Page_pipeline$fragmentType,
|};
export type Page_pipeline$key = {
  +$data?: Page_pipeline$data,
  +$fragmentSpreads: Page_pipeline$fragmentType,
  ...
};
*/

var node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "teams"
        ]
      }
    ]
  },
  "name": "Page_pipeline",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamChooser_pipeline"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TeamRow_organization"
        }
      ],
      "storageKey": null
    },
    {
      "alias": "teams",
      "args": null,
      "concreteType": "TeamPipelineConnection",
      "kind": "LinkedField",
      "name": "__Page_pipeline_teams_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamPipelineEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamPipeline",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "TeamRow_teamPipeline"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Pipeline",
  "abstractKey": null
};
})();

(node/*: any*/).hash = "7129ac29b0cde63ab739c01eecde67a8";

module.exports = ((node/*: any*/)/*: Fragment<
  Page_pipeline$fragmentType,
  Page_pipeline$data,
>*/);
